<template>
  <div class="bg-gray-500 pb-8 pt-[60px] lg:pb-12">
    <Container class="flex flex-col justify-center text-gray-100">
      <div class="mt-12 flex w-full justify-between border-b border-gray-300 pb-4 md:mt-8">
        <JobBackLink default="/careers/jobs" />
        <SharePopover title="Share this job" />
      </div>
    </Container>
  </div>
</template>

<script setup lang="ts"></script>
